// API configuration for both main and admin backends
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001/api';
export const ADMIN_API_URL = import.meta.env.VITE_ADMIN_API_URL || 'http://localhost:5002/api/admin';

// Helper to get auth token
export const getAuthToken = () => {
    return localStorage.getItem('token');
};

// Helper for API calls with auth
export const apiFetch = async (url, options = {}) => {
    const token = getAuthToken();
    const headers = {
        'Content-Type': 'application/json',
        ...options.headers,
    };
    
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    return fetch(url, {
        credentials: 'include',
        ...options,
        headers,
    });
};
